
















import ECharts from 'vue-echarts'
import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import Month from "./parts/month.vue"
import {
	GetAbnormityStatistics
} from "@/api/report"

@Component({
	components: {ECharts, Month}
})
export default class Age extends AbpBase {
	tab:String = 'default'
	tabs:Array<any> = []
	loading = false
	year = new Date()
	echartsData: any = {
		tooltip: {
			trigger: 'axis'
		},
		// 数据标题
		legend: {
			data: ['数量']
		},
		grid: {
			left: '3%',
			right: '4%',
			bottom: '3%',
			containLabel: true
		},
		toolbox: {
			feature: {
				saveAsImage: {}
			}
		},
		xAxis: {
			type: 'category',
			boundaryGap: false,
			data: [] // X轴坐标点
		},
		yAxis: {
			type: 'value'
		},
		series: [
			{
				name:'数量',
				type:'line',
				stack: '总量',
				data:[]
			},
		]
	}
	data: any = []
	tabClick(name:String){
		this.tab = name
	}
	tabRemove(name:any){
		let pos = 0
		this.tabs.forEach((item:any, index:any) => {
			if (item.type === name) {
				pos = index
			}
		})
		if (pos) {
			this.tabs.splice(pos, 1)
		}
	}
	columns = [
		{
			title: "时间",
			key: 'type'
		},
		{
			title: "人数",
			key: 'count'
		},
		{
			title: "操作",
			render: (h: any, p: any) => {
				return h('Button', {
					props: {
						type: 'primary'
					},
					on: {
						click:() => {
							this.monthClick(p)
						}
					}
				}, "详情")
			}
		}
	]
	monthClick(p:any){
		if (p.row.abnormityItems.length) {
			if (!this.tabs.length) {
				this.tabs.push({
					name: p.row.type,
					data: p.row.abnormityItems
				})
				this.tab = p.row.type
			} else {
				let contain = false
				this.tabs.forEach((item:any)=>{
					if (item.type === p.row.type) {
						contain = true
					}
				})
				if (!contain) {
					this.tabs.push({
						name: p.row.type,
						data: p.row.abnormityItems
					})
				}
				this.tab = p.row.type
			}
		} else {
			this.$Message.info("该月份没有详情展示！")
		}
	}
	created() {
		this.getData()
	}

	private async getData() {
		this.loading = true
		let query: any = {
			year: this.year.getFullYear()
		}
		let res = await GetAbnormityStatistics(query)
		this.data = res.objects
		// this.data = [
		// 	{
		// 		"abnormityItems":[
		// 			{
		// 				typeId: 1,
		// 				patientName: '张三',
		// 				startDate: '2019-06-01',
		// 				endDate: '2019-06-01',
		// 				predictDuration: 4,
		// 				actualDuration: 3.9,
		// 				advanceDuration: 0.1,
		// 				reason: '血压升高'
		// 			},
		// 			{
		// 				typeId: 1,
		// 				patientName: '张三',
		// 				startDate: '2019-06-01',
		// 				endDate: '2019-06-01',
		// 				predictDuration: 4,
		// 				actualDuration: 3.9,
		// 				advanceDuration: 0.1,
		// 				reason: '血压升高'
		// 			},
		// 		],
		// 		"typeId":1,
		// 		"type":"1月",
		// 		"count":1
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":2,
		// 		"type":"2月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":3,
		// 		"type":"3月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":4,
		// 		"type":"4月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":5,
		// 		"type":"5月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":6,
		// 		"type":"6月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":7,
		// 		"type":"7月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":8,
		// 		"type":"8月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":9,
		// 		"type":"9月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":10,
		// 		"type":"10月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":11,
		// 		"type":"11月",
		// 		"count":0
		// 	},
		// 	{
		// 		"abnormityItems":[
		//
		// 		],
		// 		"typeId":12,
		// 		"type":"12月",
		// 		"count":0
		// 	}
		// ]  //模拟数据
		let xAxis:any = []
		let series = []
		this.data.forEach((item: any) => {
			xAxis.push(item.type)
			this.echartsData.series[0].data.push(item.count)
		})
		this.echartsData.xAxis.data = xAxis
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/abnormal/index.vue